import { gql } from '@apollo/client'

export const DELETE_ACTION_MUTATION = gql`
  mutation deleteAction($id: ID!) {
    deleteAction(id: $id)
  }
`
